// Static proposal assets data
// These assets are used in the pricing section of event proposals
// and can be referenced by systemAssetId in the API response

export const proposalAssetsData = [
  {
    id: 'chips',
    name: 'Chips',
    path: '/static/proposal-assets/images/chips.png',
  },
  {
    id: 'photo',
    name: 'Photo',
    path: '/static/proposal-assets/images/photo.png',
  },
  {
    id: 'glam',
    name: 'Glam',
    path: '/static/proposal-assets/images/glam.png',
  },
  {
    id: 'masks',
    name: 'Masks',
    path: '/static/proposal-assets/images/masks.png',
  },
  {
    id: 'salsa2',
    name: 'Salsa2',
    path: '/static/proposal-assets/images/salsa2.png',
  },
  {
    id: 'green-screen',
    name: 'Green Screen',
    path: '/static/proposal-assets/images/green-screen.png',
  },
  {
    id: 'boomerang',
    name: 'Boomerang',
    path: '/static/proposal-assets/videos/boomerang.mp4',
  },
  {
    id: 'video-gif',
    name: 'Video GIF',
    path: '/static/proposal-assets/videos/gif.gif',
  },
  {
    id: 'video',
    name: 'Video',
    path: '/static/proposal-assets/videos/video.mp4',
  },
];

/**
 * Resolves a proposal asset by checking for custom uploaded image first,
 * then falling back to system asset by ID
 * @param {string} imageUrl - Custom uploaded asset URL (may be the changed default)
 * @param {string} systemAssetId - Static asset ID (e.g., "live-gallery")
 * @returns {string} The resolved asset path or empty string
 */
export const resolveProposalAsset = (imageUrl, systemAssetId) => {
  if (imageUrl) {
    return imageUrl;
  }
  if (systemAssetId) {
    const systemAsset = proposalAssetsData.find((a) => a.id === systemAssetId);
    return systemAsset?.path || '';
  }
  return '';
};

/**
 * Resolves multiple proposal assets (for carousel display)
 * imageUrls[0] may contain a custom default (user changed the systemAssetId default)
 * or an empty string (user restored to systemAssetId)
 * @param {string[]} imageUrls - Array of image URLs. [0] = changed default, [1-4] = custom images
 * @param {string} systemAssetId - Static asset ID to use as fallback when imageUrls is empty
 * @returns {string[]} Array of resolved asset paths
 */
export const resolveProposalAssets = (imageUrls, systemAssetId) => {
  if (Array.isArray(imageUrls) && imageUrls.length > 0) {
    // Filter out empty strings and check if first item is empty (means use systemAssetId)
    const filteredUrls = imageUrls.filter((url) => url && url.trim() !== '');

    // If first item was empty string, use systemAssetId as first item
    if (imageUrls[0] === '' && systemAssetId) {
      const systemAsset = proposalAssetsData.find((a) => a.id === systemAssetId);
      if (systemAsset?.path) {
        return [systemAsset.path, ...filteredUrls];
      }
    }

    // If we have filtered URLs, return them
    if (filteredUrls.length > 0) {
      return filteredUrls;
    }
  }

  // Fall back to systemAssetId
  if (systemAssetId) {
    const systemAsset = proposalAssetsData.find((a) => a.id === systemAssetId);
    if (systemAsset?.path) {
      return [systemAsset.path];
    }
  }

  return [];
};
